// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.96.1/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.96.1/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.96.1/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("/src/img/m_hublogo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("/src/img/hublogo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("/src/img/bg_main_latest_news.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("/src/img/bn_01.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("/src/img/bn_02.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("/src/img/bn_03.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/src/img/bn_04.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("/src/img/bn_05.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("/src/img/bn_06.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.3.3 | MIT License | https://tailwindcss.com
*/

/*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
	box-sizing: border-box;
	border-width: 0;
	border-style: solid;
	border-color: #eeeeee;
}

::before,
::after {
	--tw-content: "";
}

html {
	line-height: 1.5;
	-webkit-text-size-adjust: 100%;
	tab-size: 4;
	font-family: Roboto, sans-serif;
	font-feature-settings: normal;
	font-variation-settings: normal;
}

body {
	margin: 0;
	line-height: inherit;
	font-family: -apple-system, BlinkMacSystemFont, "Malgun Gothic", "맑은 고딕", helvetica, "Apple SD Gothic Neo", helvetica, "나눔바른고딕 옛한글", "NanumBarunGothic YetHangul", sans-serif;
}

hr {
	height: 0;
	color: inherit;
	border-top-width: 1px;
}

abbr:where([title]) {
	-webkit-text-decoration: underline dotted;
	text-decoration: underline dotted;
}

h1,
h2,
h3,
h4,
h5,
h6 {
	font-size: inherit;
	font-weight: inherit;
}

a {
	display: flex;
	flex-direction: column;
	align-items: center;
}

b,
strong {
	font-weight: bolder;
}

code,
kbd,
samp,
pre {
	font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
	font-size: 1em;
}

small {
	font-size: 80%;
}

sub,
sup {
	font-size: 75%;
	line-height: 0;
	position: relative;
	vertical-align: baseline;
}

sub {
	bottom: -0.25em;
}

sup {
	top: -0.5em;
}

table {
	text-indent: 0;
	border-color: inherit;
	border-collapse: collapse;
}

button,
input,
optgroup,
select,
textarea {
	font-family: inherit;
	font-feature-settings: inherit;
	font-variation-settings: inherit;
	font-size: 100%;
	font-weight: inherit;
	line-height: inherit;
	color: inherit;
	margin: 0;
	padding: 0;
}

button,
select {
	text-transform: none;
}

button,
[type="button"],
[type="reset"],
[type="submit"] {
	-webkit-appearance: button;
	background-color: transparent;
	background-image: none;
}

:-moz-focusring {
	outline: auto;
}

:-moz-ui-invalid {
	box-shadow: none;
}

progress {
	vertical-align: baseline;
}

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
	height: auto;
}

[type="search"] {
	-webkit-appearance: textfield;
	outline-offset: -2px;
}

::-webkit-search-decoration {
	-webkit-appearance: none;
}

::-webkit-file-upload-button {
	-webkit-appearance: button;
	font: inherit;
}

summary {
	display: list-item;
}

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
	margin: 0;
}

fieldset {
	margin: 0;
	padding: 0;
}

legend {
	padding: 0;
}

ol,
ul,
menu {
	list-style: none;
	margin: 0;
	padding: 0;
}

dialog {
	padding: 0;
}

textarea {
	resize: vertical;
}

input::placeholder,
textarea::placeholder {
	opacity: 1;
	color: #bdbdbd;
}

button,
[role="button"] {
	cursor: pointer;
}

:disabled {
	cursor: default;
}

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
	display: block;
	vertical-align: middle;
}

img,
video {
	max-width: 100%;
	height: auto;
}

[hidden] {
	display: none;
}

.container {
	width: 100%;
}

.fixed {
	position: fixed;
}
@media only all and (min-width: 600px) and (max-width: 900px) {
	.tag {
		display: none;
	}
	.wrap .contents section {
		display: flex !important;
		flex-direction: column !important;
		align-items: center;
	}
	.wrap .contents section div {
		width: 80% !important;
	}
}

@media only all and (min-width: 300px) and (max-width: 800px) {
	.logo {
		background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat !important;
		width: 274px;
		margin: 2px 0 0 66px !important;
	}
	.logo a {
		display: block;
		height: 31px;
	}
	.tag {
		display: none;
	}
	.back {
		display: none;
	}
	.flex_a {
		display: none !important;
	}
	.wtop {
		background: #181948 !important;
		display: flex !important;
		justify-content: flex-start !important;
	}

	.qs_list button {
		display: block;
		font-size: 0.825rem !important;
		line-height: 12px;
	}

	.f_tit {
		font-size: 20px !important;
		color: #fff !important;
		margin-left: 30px !important;
	}
	.lnb {
		display: none;
	}
	.wbg {
		margin-left: 0px !important;
	}
	.wrap .contents section {
		flex-direction: column !important;
		margin-top: 46px !important;
	}
	.wtop {
		height: 60px !important;
		font-size: 17px !important;
		padding: 16px 0 0 13px !important;
	}
	.wrap .contents section div {
		width: 100% !important;
		margin: 10px auto 10px !important;
	}
	.m_menu {
		display: block !important;
	}
	.wrap {
		margin: 33px auto !important;
	}
}
@media only all and (min-width: 768px) and (max-width: 980px) {
	.tag {
		display: none;
	}
	.wrap .contents section {
		display: flex !important;
		flex-direction: column !important;
		align-items: center;
	}
	.wrap .contents section div {
		width: 63% !important;
	}
}

.lnb {
	/* margin-top: 84px; */
	width: 254px;
	height: calc(100% - 50px);
	position: fixed;
	padding-bottom: 10px;
}
.mt84 {margin-top: 84px;display: flex; flex-direction: row;}
.logo {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat;
	width: 274px;
	margin: 12px 0 0 -32px;
}
.logo a {
	display: block;
	height: 31px;
}
.m_menu {
	display: none;
}

.box {
	display: flex;
	flex-direction: row;
	align-items: center;
	width: 100%;
	margin: 0 0 20px 0;
	justify-content: space-between;
}
.wbg {
	background-color: rgb(251, 248, 255);
    /* padding-bottom: calc(90px); */
    overflow: hidden;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    background-size: auto 100%;
    background-repeat: repeat;
    margin-left: 250px;
    background-position: left top;
    width: 100%;
}
.mbtm {
	padding-bottom: calc(137px);
}
.wtop {
	display: flex;
	color: #fff;
	font-size: 24px;
	font-weight: 700;
	padding: 19px 0 0 46px;
	line-height: 150%;
	flex-direction: row;
	justify-content: space-between;
	position: fixed;
	color-scheme: light only;
	width: 100%;
	background: rgb(255, 255, 255);
	box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 14px;
	height: 80px;
	top: 0;
	z-index: 90;
	transition: all 0.3s ease 0s;
}
.back a:hover {
	transition: all 0.25s cubic-bezier(0.56, 0.56, 0.6, 1.02);
	background-color: #05c3a7;
	color: #fff;
	border: 1px solid rgba(0, 0, 0, 0);
}

.back a {
	box-sizing: border-box;
	display: inline-block;
	height: 32px;
	line-height: 31px;
	font-size: 13px;
	font-weight: 400px;
	color: #fff;
	padding: 0 8px;
	border: 1px solid rgba(0, 0, 0, 0.12);
	border-radius: 6px;
	--tw-bg-opacity: 1;
}
.top-btn-bg-color {
	background-color: rgb(15 23 42 / var(--tw-bg-opacity));
}
.top-btn-bg-color-blue {
	background-color: rgba(0, 119, 254, 1);
}
.f_tit {
	font-size: 1.425rem;
	color: #000;
}
.fs_tit {
	font-size: 15px;
	color: #666;
}
.back {
	font-size: 14px;
	margin: 0px 0px 8px 20px;
}
.mr-5 {
	margin-right: 5px;
}
.wrap {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 30px;
	width: 100%;
	max-width: 1136px;
	margin: 50px auto;
	flex-direction: column;
}
.wrap .tit {
	font-size: 29px;
	color: #444;
	font-weight: 700;
	line-height: 150%;
	margin: 0 0 15px 0;
	letter-spacing: -1px;
}
.wrap .contents {
	display: flex;
	position: relative;
	width: 100%;
	max-width: 1440px;
	margin: 0px auto;
	flex-direction: column;
	padding: 0 50px 0 50px;
}
.wrap .contents section {
	display: flex;
	flex-direction: row;
}
.wrap .contents section div {
	width: calc(33.3333% - 16.6667px);
	display: flex;
	flex-direction: column;
	background-color: rgb(255, 255, 255);
	height: 100%;
	min-height: 225px;
	/* padding-bottom: 50px; */
	box-shadow: rgba(157, 182, 221, 0.2) 15px 10px 30px, rgba(157, 182, 221, 0.2) 15px 15px 25px;
	border-radius: 20px;
	transition: transform 0.3s ease 0s;
	cursor: pointer;
	margin-right: 29px;
	margin-bottom: 41px;
	justify-content: center;
	align-items: center;
	padding: 10px 30px 30px 30px;
}

.bn01 {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) top center no-repeat;
	display: block;
	height: 80px;
	background-size: 80px;
	opacity: 0.7;
	width: 80px;
}
.bn02 {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) top center no-repeat;
	display: block;
	height: 80px;
	background-size: 80px;
	opacity: 0.7;
	width: 80px;
}
.bn03 {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) top center no-repeat;
	display: block;
	height: 80px;
	background-size: 80px;
	opacity: 0.7;
	width: 80px;
}
.bn04 {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) top center no-repeat;
	display: block;
	height: 80px;
	background-size: 80px;
	opacity: 0.7;
	width: 80px;
}
.bn05 {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) top center no-repeat;
	display: block;
	height: 80px;
	background-size: 80px;
	opacity: 0.7;
	width: 80px;
}
.bn06 {
	background: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) top center no-repeat;
	display: block;
	height: 80px;
	background-size: 80px;
	opacity: 0.7;
	width: 80px;
}
.x_tit {
	font-size: 27px;
	letter-spacing: -1px;
}
.x_tit em {
	font-size: 11px;
	color: #888;
}
.s_tit {
	font-size: 12px;
	color: #999;
}
.b_tit {
	font-size: 15px;
	font-weight: 400;
	color: #a0a2a3;
	line-height: 19px;
	letter-spacing: -1px;
}
.p_tit {
	padding: 0px 0 7px;
	color: #333;
	font-size: 22px;
	line-height: 24px;
	letter-spacing: -1px;
	font-weight: 600;
}

/* 레프트 메뉴 */
.theme {
	align-items: center;
	font-weight: 600;
	font-size: 0.875rem;
	color: rgb(14 165 233 / var(--tw-text-opacity));
	display: flex;
	font-family: Inter var, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
}
.lnb_font {
	--tw-text-opacity: 1;
	font-size: 0.875rem;
	font-weight: 600;
	font-family: Inter var, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;
}
.lnb_depth1 {
	--tw-border-opacity: 1;
	font-size: 0.875rem;
	line-height: 1.25rem;
	margin-left: 18px;
	background-color: transparent;
	border-left: 1px solid #eef3f8;
}

.lnb_depth2:hover,
.lnb_depth2:active {
	border-left: 1px solid #0ea5e9;
	border-radius: 0;
	background: none;
	color: #0ea5e9;
	font-weight: bold;
}

.lnb_depth2 a:visited {
	border-left: 1px solid #0ea5e9;
	border-radius: 0;
	background: none;
	font-weight: bold;
}

.lnb_depth2 {
	background: none;
	font-size: 0.875rem;
	line-height: 1.25rem;
	background-color: transparent;
	padding: 0.25rem 1rem 0.25rem 1rem;
	margin-bottom: 0;
	border-radius: 0;
}
.title_area {
	margin-right: 28px;
	box-shadow: rgba(157, 182, 221, 0.2) 15px 10px 30px, rgba(157, 182, 221, 0.2) 15px 15px 25px;
	border-radius: 20px;
	background: #fff;
	padding: 20px;
	margin-bottom: 40px;
}
.qs {
	font-size: 16px;
	font-weight: bold;
	color: #101010;
	line-height: 25px;
	letter-spacing: -0.4px;
	margin-right: 10px;
	font-family: -apple-system, BlinkMacSystemFont, "Apple SD Gothic Neo", Arial, "Malgun Gothic", "맑은 고딕", Dotum, 돋움, sans-serif;
}
.qs_area {
	display: flex;
}
.qs_sub {
	color: #404040;
	margin-top: 5px;
	font-size: 13px;
	font-weight: 500;
	line-height: 17px;
}
.qs_list {
	display: flex;
}
.qs_list button {
	display: block;
	margin: 10px 10px 0 0;
	height: 38px;
	padding: 0 13px;
	border: 1px solid #e6e6ea;
	border-radius: 19px;
	line-height: 17px;
	font-size: 15px;
	border-color: #ebebeb;
	color: #101010;
}

.qs_list button:hover {
	border-color: rgba(65, 115, 245, 0.3);
	background-color: #ecf1fe;
	color: #4173f5 !important;
	font-weight: 700;
}

.text-sky-500 {
	--tw-text-opacity: 1;
	color: rgb(14 165 233 / var(--tw-text-opacity));
}
.text-slate-900 {
	--tw-text-opacity: 1;
	color: rgb(15 23 42 / var(--tw-text-opacity));
}
.flex_a {
	display: flex;
	align-items: flex-end;
}
.hover\\:border-slate-300:hover {
	--tw-border-opacity: 1;
	border-color: rgb(203 213 225 / var(--tw-border-opacity));
}
.pointer {
	cursor: pointer;
}

.border_0{border-radius: 0 !important;}
.shadow{box-shadow: none !important;}
`, "",{"version":3,"sources":["webpack://./src/css/output.css"],"names":[],"mappings":"AAAA;;CAEC;;AAED;;;CAGC;;AAED;;;CAGC,sBAAsB;CACtB,eAAe;CACf,mBAAmB;CACnB,qBAAqB;AACtB;;AAEA;;CAEC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,8BAA8B;CAC9B,WAAW;CACX,+BAA+B;CAE/B,6BAA6B;CAC7B,+BAA+B;AAChC;;AAEA;CACC,SAAS;CACT,oBAAoB;CACpB,6KAA6K;AAC9K;;AAEA;CACC,SAAS;CACT,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,yCAAyC;CACzC,iCAAiC;AAClC;;AAEA;;;;;;CAMC,kBAAkB;CAClB,oBAAoB;AACrB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;;CAEC,mBAAmB;AACpB;;AAEA;;;;CAIC,+GAA+G;CAC/G,cAAc;AACf;;AAEA;CACC,cAAc;AACf;;AAEA;;CAEC,cAAc;CACd,cAAc;CACd,kBAAkB;CAClB,wBAAwB;AACzB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,cAAc;CACd,qBAAqB;CACrB,yBAAyB;AAC1B;;AAEA;;;;;CAKC,oBAAoB;CAEpB,8BAA8B;CAC9B,gCAAgC;CAChC,eAAe;CACf,oBAAoB;CACpB,oBAAoB;CACpB,cAAc;CACd,SAAS;CACT,UAAU;AACX;;AAEA;;CAEC,oBAAoB;AACrB;;AAEA;;;;CAIC,0BAA0B;CAC1B,6BAA6B;CAC7B,sBAAsB;AACvB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;;CAEC,YAAY;AACb;;AAEA;CACC,6BAA6B;CAC7B,oBAAoB;AACrB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,0BAA0B;CAC1B,aAAa;AACd;;AAEA;CACC,kBAAkB;AACnB;;AAEA;;;;;;;;;;;;;CAaC,SAAS;AACV;;AAEA;CACC,SAAS;CACT,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;;;CAGC,gBAAgB;CAChB,SAAS;CACT,UAAU;AACX;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,gBAAgB;AACjB;;AAQA;;CAEC,UAAU;CACV,cAAc;AACf;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;;;;;;;;CAQC,cAAc;CACd,sBAAsB;AACvB;;AAEA;;CAEC,eAAe;CACf,YAAY;AACb;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,eAAe;AAChB;AACA;CACC;EACC,aAAa;CACd;CACA;EACC,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;CACpB;CACA;EACC,qBAAqB;CACtB;AACD;;AAEA;CACC;EACC,wEAA4D;EAC5D,YAAY;EACZ,+BAA+B;CAChC;CACA;EACC,cAAc;EACd,YAAY;CACb;CACA;EACC,aAAa;CACd;CACA;EACC,aAAa;CACd;CACA;EACC,wBAAwB;CACzB;CACA;EACC,8BAA8B;EAC9B,wBAAwB;EACxB,sCAAsC;CACvC;;CAEA;EACC,cAAc;EACd,8BAA8B;EAC9B,iBAAiB;CAClB;;CAEA;EACC,0BAA0B;EAC1B,sBAAsB;EACtB,4BAA4B;CAC7B;CACA;EACC,aAAa;CACd;CACA;EACC,2BAA2B;CAC5B;CACA;EACC,iCAAiC;EACjC,2BAA2B;CAC5B;CACA;EACC,uBAAuB;EACvB,0BAA0B;EAC1B,iCAAiC;CAClC;CACA;EACC,sBAAsB;EACtB,iCAAiC;CAClC;CACA;EACC,yBAAyB;CAC1B;CACA;EACC,4BAA4B;CAC7B;AACD;AACA;CACC;EACC,aAAa;CACd;CACA;EACC,wBAAwB;EACxB,iCAAiC;EACjC,mBAAmB;CACpB;CACA;EACC,qBAAqB;CACtB;AACD;;AAEA;CACC,sBAAsB;CACtB,YAAY;CACZ,yBAAyB;CACzB,eAAe;CACf,oBAAoB;AACrB;AACA,OAAO,gBAAgB,CAAC,aAAa,EAAE,mBAAmB,CAAC;AAC3D;CACC,6DAA+C;CAC/C,YAAY;CACZ,sBAAsB;AACvB;AACA;CACC,cAAc;CACd,YAAY;AACb;AACA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,mBAAmB;CACnB,WAAW;CACX,kBAAkB;CAClB,8BAA8B;AAC/B;AACA;CACC,oCAAoC;IACjC,gCAAgC;IAChC,gBAAgB;IAChB,yDAAuD;IACvD,0BAA0B;IAC1B,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;IAC7B,WAAW;AACf;AACA;CACC,2BAA2B;AAC5B;AACA;CACC,aAAa;CACb,WAAW;CACX,eAAe;CACf,gBAAgB;CAChB,sBAAsB;CACtB,iBAAiB;CACjB,mBAAmB;CACnB,8BAA8B;CAC9B,eAAe;CACf,wBAAwB;CACxB,WAAW;CACX,8BAA8B;CAC9B,2CAA2C;CAC3C,YAAY;CACZ,MAAM;CACN,WAAW;CACX,4BAA4B;AAC7B;AACA;CACC,yDAAyD;CACzD,yBAAyB;CACzB,WAAW;CACX,kCAAkC;AACnC;;AAEA;CACC,sBAAsB;CACtB,qBAAqB;CACrB,YAAY;CACZ,iBAAiB;CACjB,eAAe;CACf,kBAAkB;CAClB,WAAW;CACX,cAAc;CACd,qCAAqC;CACrC,kBAAkB;CAClB,kBAAkB;AACnB;AACA;CACC,sDAAsD;AACvD;AACA;CACC,sCAAsC;AACvC;AACA;CACC,mBAAmB;CACnB,WAAW;AACZ;AACA;CACC,eAAe;CACf,WAAW;AACZ;AACA;CACC,eAAe;CACf,wBAAwB;AACzB;AACA;CACC,iBAAiB;AAClB;AACA;CACC,aAAa;CAEb,mBAAmB;CAEnB,uBAAuB;CACvB,SAAS;CACT,WAAW;CACX,iBAAiB;CACjB,iBAAiB;CACjB,sBAAsB;AACvB;AACA;CACC,eAAe;CACf,WAAW;CACX,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB,oBAAoB;AACrB;AACA;CACC,aAAa;CACb,kBAAkB;CAClB,WAAW;CACX,iBAAiB;CACjB,gBAAgB;CAChB,sBAAsB;CACtB,sBAAsB;AACvB;AACA;CACC,aAAa;CACb,mBAAmB;AACpB;AACA;CACC,iCAAiC;CACjC,aAAa;CACb,sBAAsB;CACtB,oCAAoC;CACpC,YAAY;CACZ,iBAAiB;CACjB,0BAA0B;CAC1B,4FAA4F;CAC5F,mBAAmB;CACnB,kCAAkC;CAClC,eAAe;CACf,kBAAkB;CAClB,mBAAmB;CACnB,uBAAuB;CACvB,mBAAmB;CACnB,4BAA4B;AAC7B;;AAEA;CACC,wEAAwD;CACxD,cAAc;CACd,YAAY;CACZ,qBAAqB;CACrB,YAAY;CACZ,WAAW;AACZ;AACA;CACC,wEAAwD;CACxD,cAAc;CACd,YAAY;CACZ,qBAAqB;CACrB,YAAY;CACZ,WAAW;AACZ;AACA;CACC,wEAAwD;CACxD,cAAc;CACd,YAAY;CACZ,qBAAqB;CACrB,YAAY;CACZ,WAAW;AACZ;AACA;CACC,wEAAwD;CACxD,cAAc;CACd,YAAY;CACZ,qBAAqB;CACrB,YAAY;CACZ,WAAW;AACZ;AACA;CACC,wEAAwD;CACxD,cAAc;CACd,YAAY;CACZ,qBAAqB;CACrB,YAAY;CACZ,WAAW;AACZ;AACA;CACC,wEAAwD;CACxD,cAAc;CACd,YAAY;CACZ,qBAAqB;CACrB,YAAY;CACZ,WAAW;AACZ;AACA;CACC,eAAe;CACf,oBAAoB;AACrB;AACA;CACC,eAAe;CACf,WAAW;AACZ;AACA;CACC,eAAe;CACf,WAAW;AACZ;AACA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,iBAAiB;CACjB,oBAAoB;AACrB;AACA;CACC,kBAAkB;CAClB,WAAW;CACX,eAAe;CACf,iBAAiB;CACjB,oBAAoB;CACpB,gBAAgB;AACjB;;AAEA,WAAW;AACX;CACC,mBAAmB;CACnB,gBAAgB;CAChB,mBAAmB;CACnB,+CAA+C;CAC/C,aAAa;CACb,yNAAyN;AAC1N;AACA;CACC,oBAAoB;CACpB,mBAAmB;CACnB,gBAAgB;CAChB,yNAAyN;AAC1N;AACA;CACC,sBAAsB;CACtB,mBAAmB;CACnB,oBAAoB;CACpB,iBAAiB;CACjB,6BAA6B;CAC7B,8BAA8B;AAC/B;;AAEA;;CAEC,8BAA8B;CAC9B,gBAAgB;CAChB,gBAAgB;CAChB,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,8BAA8B;CAC9B,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,oBAAoB;CACpB,6BAA6B;CAC7B,kCAAkC;CAClC,gBAAgB;CAChB,gBAAgB;AACjB;AACA;CACC,kBAAkB;CAClB,4FAA4F;CAC5F,mBAAmB;CACnB,gBAAgB;CAChB,aAAa;CACb,mBAAmB;AACpB;AACA;CACC,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,iBAAiB;CACjB,sBAAsB;CACtB,kBAAkB;CAClB,6HAA6H;AAC9H;AACA;CACC,aAAa;AACd;AACA;CACC,cAAc;CACd,eAAe;CACf,eAAe;CACf,gBAAgB;CAChB,iBAAiB;AAClB;AACA;CACC,aAAa;AACd;AACA;CACC,cAAc;CACd,qBAAqB;CACrB,YAAY;CACZ,eAAe;CACf,yBAAyB;CACzB,mBAAmB;CACnB,iBAAiB;CACjB,eAAe;CACf,qBAAqB;CACrB,cAAc;AACf;;AAEA;CACC,qCAAqC;CACrC,yBAAyB;CACzB,yBAAyB;CACzB,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;CACpB,+CAA+C;AAChD;AACA;CACC,oBAAoB;CACpB,6CAA6C;AAC9C;AACA;CACC,aAAa;CACb,qBAAqB;AACtB;AACA;CACC,sBAAsB;CACtB,yDAAyD;AAC1D;AACA;CACC,eAAe;AAChB;;AAEA,UAAU,2BAA2B,CAAC;AACtC,QAAQ,2BAA2B,CAAC","sourcesContent":["/*\n! tailwindcss v3.3.3 | MIT License | https://tailwindcss.com\n*/\n\n/*\n1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)\n2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)\n*/\n\n*,\n::before,\n::after {\n\tbox-sizing: border-box;\n\tborder-width: 0;\n\tborder-style: solid;\n\tborder-color: #eeeeee;\n}\n\n::before,\n::after {\n\t--tw-content: \"\";\n}\n\nhtml {\n\tline-height: 1.5;\n\t-webkit-text-size-adjust: 100%;\n\ttab-size: 4;\n\tfont-family: Roboto, sans-serif;\n\t-webkit-font-feature-settings: normal;\n\tfont-feature-settings: normal;\n\tfont-variation-settings: normal;\n}\n\nbody {\n\tmargin: 0;\n\tline-height: inherit;\n\tfont-family: -apple-system, BlinkMacSystemFont, \"Malgun Gothic\", \"맑은 고딕\", helvetica, \"Apple SD Gothic Neo\", helvetica, \"나눔바른고딕 옛한글\", \"NanumBarunGothic YetHangul\", sans-serif;\n}\n\nhr {\n\theight: 0;\n\tcolor: inherit;\n\tborder-top-width: 1px;\n}\n\nabbr:where([title]) {\n\t-webkit-text-decoration: underline dotted;\n\ttext-decoration: underline dotted;\n}\n\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n\tfont-size: inherit;\n\tfont-weight: inherit;\n}\n\na {\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n}\n\nb,\nstrong {\n\tfont-weight: bolder;\n}\n\ncode,\nkbd,\nsamp,\npre {\n\tfont-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n\tfont-size: 1em;\n}\n\nsmall {\n\tfont-size: 80%;\n}\n\nsub,\nsup {\n\tfont-size: 75%;\n\tline-height: 0;\n\tposition: relative;\n\tvertical-align: baseline;\n}\n\nsub {\n\tbottom: -0.25em;\n}\n\nsup {\n\ttop: -0.5em;\n}\n\ntable {\n\ttext-indent: 0;\n\tborder-color: inherit;\n\tborder-collapse: collapse;\n}\n\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n\tfont-family: inherit;\n\t-webkit-font-feature-settings: inherit;\n\tfont-feature-settings: inherit;\n\tfont-variation-settings: inherit;\n\tfont-size: 100%;\n\tfont-weight: inherit;\n\tline-height: inherit;\n\tcolor: inherit;\n\tmargin: 0;\n\tpadding: 0;\n}\n\nbutton,\nselect {\n\ttext-transform: none;\n}\n\nbutton,\n[type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n\t-webkit-appearance: button;\n\tbackground-color: transparent;\n\tbackground-image: none;\n}\n\n:-moz-focusring {\n\toutline: auto;\n}\n\n:-moz-ui-invalid {\n\tbox-shadow: none;\n}\n\nprogress {\n\tvertical-align: baseline;\n}\n\n::-webkit-inner-spin-button,\n::-webkit-outer-spin-button {\n\theight: auto;\n}\n\n[type=\"search\"] {\n\t-webkit-appearance: textfield;\n\toutline-offset: -2px;\n}\n\n::-webkit-search-decoration {\n\t-webkit-appearance: none;\n}\n\n::-webkit-file-upload-button {\n\t-webkit-appearance: button;\n\tfont: inherit;\n}\n\nsummary {\n\tdisplay: list-item;\n}\n\nblockquote,\ndl,\ndd,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6,\nhr,\nfigure,\np,\npre {\n\tmargin: 0;\n}\n\nfieldset {\n\tmargin: 0;\n\tpadding: 0;\n}\n\nlegend {\n\tpadding: 0;\n}\n\nol,\nul,\nmenu {\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0;\n}\n\ndialog {\n\tpadding: 0;\n}\n\ntextarea {\n\tresize: vertical;\n}\n\ninput::-webkit-input-placeholder,\ntextarea::-webkit-input-placeholder {\n\topacity: 1;\n\tcolor: #bdbdbd;\n}\n\ninput::placeholder,\ntextarea::placeholder {\n\topacity: 1;\n\tcolor: #bdbdbd;\n}\n\nbutton,\n[role=\"button\"] {\n\tcursor: pointer;\n}\n\n:disabled {\n\tcursor: default;\n}\n\nimg,\nsvg,\nvideo,\ncanvas,\naudio,\niframe,\nembed,\nobject {\n\tdisplay: block;\n\tvertical-align: middle;\n}\n\nimg,\nvideo {\n\tmax-width: 100%;\n\theight: auto;\n}\n\n[hidden] {\n\tdisplay: none;\n}\n\n.container {\n\twidth: 100%;\n}\n\n.fixed {\n\tposition: fixed;\n}\n@media only all and (min-width: 600px) and (max-width: 900px) {\n\t.tag {\n\t\tdisplay: none;\n\t}\n\t.wrap .contents section {\n\t\tdisplay: flex !important;\n\t\tflex-direction: column !important;\n\t\talign-items: center;\n\t}\n\t.wrap .contents section div {\n\t\twidth: 80% !important;\n\t}\n}\n\n@media only all and (min-width: 300px) and (max-width: 800px) {\n\t.logo {\n\t\tbackground: url(/src/img/m_hublogo.png) no-repeat !important;\n\t\twidth: 274px;\n\t\tmargin: 2px 0 0 66px !important;\n\t}\n\t.logo a {\n\t\tdisplay: block;\n\t\theight: 31px;\n\t}\n\t.tag {\n\t\tdisplay: none;\n\t}\n\t.back {\n\t\tdisplay: none;\n\t}\n\t.flex_a {\n\t\tdisplay: none !important;\n\t}\n\t.wtop {\n\t\tbackground: #181948 !important;\n\t\tdisplay: flex !important;\n\t\tjustify-content: flex-start !important;\n\t}\n\n\t.qs_list button {\n\t\tdisplay: block;\n\t\tfont-size: 0.825rem !important;\n\t\tline-height: 12px;\n\t}\n\n\t.f_tit {\n\t\tfont-size: 20px !important;\n\t\tcolor: #fff !important;\n\t\tmargin-left: 30px !important;\n\t}\n\t.lnb {\n\t\tdisplay: none;\n\t}\n\t.wbg {\n\t\tmargin-left: 0px !important;\n\t}\n\t.wrap .contents section {\n\t\tflex-direction: column !important;\n\t\tmargin-top: 46px !important;\n\t}\n\t.wtop {\n\t\theight: 60px !important;\n\t\tfont-size: 17px !important;\n\t\tpadding: 16px 0 0 13px !important;\n\t}\n\t.wrap .contents section div {\n\t\twidth: 100% !important;\n\t\tmargin: 10px auto 10px !important;\n\t}\n\t.m_menu {\n\t\tdisplay: block !important;\n\t}\n\t.wrap {\n\t\tmargin: 33px auto !important;\n\t}\n}\n@media only all and (min-width: 768px) and (max-width: 980px) {\n\t.tag {\n\t\tdisplay: none;\n\t}\n\t.wrap .contents section {\n\t\tdisplay: flex !important;\n\t\tflex-direction: column !important;\n\t\talign-items: center;\n\t}\n\t.wrap .contents section div {\n\t\twidth: 63% !important;\n\t}\n}\n\n.lnb {\n\t/* margin-top: 84px; */\n\twidth: 254px;\n\theight: calc(100% - 50px);\n\tposition: fixed;\n\tpadding-bottom: 10px;\n}\n.mt84 {margin-top: 84px;display: flex; flex-direction: row;}\n.logo {\n\tbackground: url(/src/img/hublogo.png) no-repeat;\n\twidth: 274px;\n\tmargin: 12px 0 0 -32px;\n}\n.logo a {\n\tdisplay: block;\n\theight: 31px;\n}\n.m_menu {\n\tdisplay: none;\n}\n\n.box {\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\twidth: 100%;\n\tmargin: 0 0 20px 0;\n\tjustify-content: space-between;\n}\n.wbg {\n\tbackground-color: rgb(251, 248, 255);\n    /* padding-bottom: calc(90px); */\n    overflow: hidden;\n    background-image: url(/src/img/bg_main_latest_news.png);\n    background-size: auto 100%;\n    background-repeat: repeat;\n    margin-left: 250px;\n    background-position: left top;\n    width: 100%;\n}\n.mbtm {\n\tpadding-bottom: calc(137px);\n}\n.wtop {\n\tdisplay: flex;\n\tcolor: #fff;\n\tfont-size: 24px;\n\tfont-weight: 700;\n\tpadding: 19px 0 0 46px;\n\tline-height: 150%;\n\tflex-direction: row;\n\tjustify-content: space-between;\n\tposition: fixed;\n\tcolor-scheme: light only;\n\twidth: 100%;\n\tbackground: rgb(255, 255, 255);\n\tbox-shadow: rgba(0, 0, 0, 0.1) 0px 0px 14px;\n\theight: 80px;\n\ttop: 0;\n\tz-index: 90;\n\ttransition: all 0.3s ease 0s;\n}\n.back a:hover {\n\ttransition: all 0.25s cubic-bezier(0.56, 0.56, 0.6, 1.02);\n\tbackground-color: #05c3a7;\n\tcolor: #fff;\n\tborder: 1px solid rgba(0, 0, 0, 0);\n}\n\n.back a {\n\tbox-sizing: border-box;\n\tdisplay: inline-block;\n\theight: 32px;\n\tline-height: 31px;\n\tfont-size: 13px;\n\tfont-weight: 400px;\n\tcolor: #fff;\n\tpadding: 0 8px;\n\tborder: 1px solid rgba(0, 0, 0, 0.12);\n\tborder-radius: 6px;\n\t--tw-bg-opacity: 1;\n}\n.top-btn-bg-color {\n\tbackground-color: rgb(15 23 42 / var(--tw-bg-opacity));\n}\n.top-btn-bg-color-blue {\n\tbackground-color: rgba(0, 119, 254, 1);\n}\n.f_tit {\n\tfont-size: 1.425rem;\n\tcolor: #000;\n}\n.fs_tit {\n\tfont-size: 15px;\n\tcolor: #666;\n}\n.back {\n\tfont-size: 14px;\n\tmargin: 0px 0px 8px 20px;\n}\n.mr-5 {\n\tmargin-right: 5px;\n}\n.wrap {\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\talign-items: center;\n\t-webkit-box-pack: center;\n\tjustify-content: center;\n\tgap: 30px;\n\twidth: 100%;\n\tmax-width: 1136px;\n\tmargin: 50px auto;\n\tflex-direction: column;\n}\n.wrap .tit {\n\tfont-size: 29px;\n\tcolor: #444;\n\tfont-weight: 700;\n\tline-height: 150%;\n\tmargin: 0 0 15px 0;\n\tletter-spacing: -1px;\n}\n.wrap .contents {\n\tdisplay: flex;\n\tposition: relative;\n\twidth: 100%;\n\tmax-width: 1440px;\n\tmargin: 0px auto;\n\tflex-direction: column;\n\tpadding: 0 50px 0 50px;\n}\n.wrap .contents section {\n\tdisplay: flex;\n\tflex-direction: row;\n}\n.wrap .contents section div {\n\twidth: calc(33.3333% - 16.6667px);\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground-color: rgb(255, 255, 255);\n\theight: 100%;\n\tmin-height: 225px;\n\t/* padding-bottom: 50px; */\n\tbox-shadow: rgba(157, 182, 221, 0.2) 15px 10px 30px, rgba(157, 182, 221, 0.2) 15px 15px 25px;\n\tborder-radius: 20px;\n\ttransition: transform 0.3s ease 0s;\n\tcursor: pointer;\n\tmargin-right: 29px;\n\tmargin-bottom: 41px;\n\tjustify-content: center;\n\talign-items: center;\n\tpadding: 10px 30px 30px 30px;\n}\n\n.bn01 {\n\tbackground: url(/src/img/bn_01.jpg) top center no-repeat;\n\tdisplay: block;\n\theight: 80px;\n\tbackground-size: 80px;\n\topacity: 0.7;\n\twidth: 80px;\n}\n.bn02 {\n\tbackground: url(/src/img/bn_02.jpg) top center no-repeat;\n\tdisplay: block;\n\theight: 80px;\n\tbackground-size: 80px;\n\topacity: 0.7;\n\twidth: 80px;\n}\n.bn03 {\n\tbackground: url(/src/img/bn_03.jpg) top center no-repeat;\n\tdisplay: block;\n\theight: 80px;\n\tbackground-size: 80px;\n\topacity: 0.7;\n\twidth: 80px;\n}\n.bn04 {\n\tbackground: url(/src/img/bn_04.jpg) top center no-repeat;\n\tdisplay: block;\n\theight: 80px;\n\tbackground-size: 80px;\n\topacity: 0.7;\n\twidth: 80px;\n}\n.bn05 {\n\tbackground: url(/src/img/bn_05.jpg) top center no-repeat;\n\tdisplay: block;\n\theight: 80px;\n\tbackground-size: 80px;\n\topacity: 0.7;\n\twidth: 80px;\n}\n.bn06 {\n\tbackground: url(/src/img/bn_06.jpg) top center no-repeat;\n\tdisplay: block;\n\theight: 80px;\n\tbackground-size: 80px;\n\topacity: 0.7;\n\twidth: 80px;\n}\n.x_tit {\n\tfont-size: 27px;\n\tletter-spacing: -1px;\n}\n.x_tit em {\n\tfont-size: 11px;\n\tcolor: #888;\n}\n.s_tit {\n\tfont-size: 12px;\n\tcolor: #999;\n}\n.b_tit {\n\tfont-size: 15px;\n\tfont-weight: 400;\n\tcolor: #a0a2a3;\n\tline-height: 19px;\n\tletter-spacing: -1px;\n}\n.p_tit {\n\tpadding: 0px 0 7px;\n\tcolor: #333;\n\tfont-size: 22px;\n\tline-height: 24px;\n\tletter-spacing: -1px;\n\tfont-weight: 600;\n}\n\n/* 레프트 메뉴 */\n.theme {\n\talign-items: center;\n\tfont-weight: 600;\n\tfont-size: 0.875rem;\n\tcolor: rgb(14 165 233 / var(--tw-text-opacity));\n\tdisplay: flex;\n\tfont-family: Inter var, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;\n}\n.lnb_font {\n\t--tw-text-opacity: 1;\n\tfont-size: 0.875rem;\n\tfont-weight: 600;\n\tfont-family: Inter var, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji;\n}\n.lnb_depth1 {\n\t--tw-border-opacity: 1;\n\tfont-size: 0.875rem;\n\tline-height: 1.25rem;\n\tmargin-left: 18px;\n\tbackground-color: transparent;\n\tborder-left: 1px solid #eef3f8;\n}\n\n.lnb_depth2:hover,\n.lnb_depth2:active {\n\tborder-left: 1px solid #0ea5e9;\n\tborder-radius: 0;\n\tbackground: none;\n\tcolor: #0ea5e9;\n\tfont-weight: bold;\n}\n\n.lnb_depth2 a:visited {\n\tborder-left: 1px solid #0ea5e9;\n\tborder-radius: 0;\n\tbackground: none;\n\tfont-weight: bold;\n}\n\n.lnb_depth2 {\n\tbackground: none;\n\tfont-size: 0.875rem;\n\tline-height: 1.25rem;\n\tbackground-color: transparent;\n\tpadding: 0.25rem 1rem 0.25rem 1rem;\n\tmargin-bottom: 0;\n\tborder-radius: 0;\n}\n.title_area {\n\tmargin-right: 28px;\n\tbox-shadow: rgba(157, 182, 221, 0.2) 15px 10px 30px, rgba(157, 182, 221, 0.2) 15px 15px 25px;\n\tborder-radius: 20px;\n\tbackground: #fff;\n\tpadding: 20px;\n\tmargin-bottom: 40px;\n}\n.qs {\n\tfont-size: 16px;\n\tfont-weight: bold;\n\tcolor: #101010;\n\tline-height: 25px;\n\tletter-spacing: -0.4px;\n\tmargin-right: 10px;\n\tfont-family: -apple-system, BlinkMacSystemFont, \"Apple SD Gothic Neo\", Arial, \"Malgun Gothic\", \"맑은 고딕\", Dotum, 돋움, sans-serif;\n}\n.qs_area {\n\tdisplay: flex;\n}\n.qs_sub {\n\tcolor: #404040;\n\tmargin-top: 5px;\n\tfont-size: 13px;\n\tfont-weight: 500;\n\tline-height: 17px;\n}\n.qs_list {\n\tdisplay: flex;\n}\n.qs_list button {\n\tdisplay: block;\n\tmargin: 10px 10px 0 0;\n\theight: 38px;\n\tpadding: 0 13px;\n\tborder: 1px solid #e6e6ea;\n\tborder-radius: 19px;\n\tline-height: 17px;\n\tfont-size: 15px;\n\tborder-color: #ebebeb;\n\tcolor: #101010;\n}\n\n.qs_list button:hover {\n\tborder-color: rgba(65, 115, 245, 0.3);\n\tbackground-color: #ecf1fe;\n\tcolor: #4173f5 !important;\n\tfont-weight: 700;\n}\n\n.text-sky-500 {\n\t--tw-text-opacity: 1;\n\tcolor: rgb(14 165 233 / var(--tw-text-opacity));\n}\n.text-slate-900 {\n\t--tw-text-opacity: 1;\n\tcolor: rgb(15 23 42 / var(--tw-text-opacity));\n}\n.flex_a {\n\tdisplay: flex;\n\talign-items: flex-end;\n}\n.hover\\:border-slate-300:hover {\n\t--tw-border-opacity: 1;\n\tborder-color: rgb(203 213 225 / var(--tw-border-opacity));\n}\n.pointer {\n\tcursor: pointer;\n}\n\n.border_0{border-radius: 0 !important;}\n.shadow{box-shadow: none !important;}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
